export default "<div class=\"mt-3\">\n    <div [innerHTML]=\"data?.description\"></div>\n</div>";